export const storeSectionItemStates = {
  LOADING: 'loading',
  READY: 'ready',
  EMPTY: 'empty',
} as const;
